var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ah-search-results" },
    _vm._l(_vm.categories, function(category, i) {
      return _c(
        "div",
        { key: "product-category-" + i },
        [
          _c("product-section", {
            attrs: { heading: category.name, categoryId: category.id }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }